import { ActivatedRouteSnapshot } from '@angular/router';
import { RouterStateUrl } from '../router.model';

const getLast = (root: ActivatedRouteSnapshot) => {
  let publicRoute = root;
  let _route = root;
  let params = {};
  let data = {};

  do {
    if (!_route.firstChild) publicRoute = _route;
    params = { ...params, ..._route.params };
    data = {
      ...data,
      ...(typeof _route.data === 'object' && !!_route.data ? _route.data : {}),
    };
    _route = _route.firstChild;
  } while (_route);

  publicRoute.params = params;
  publicRoute.data = data;

  return publicRoute;
};

export const routeSerializer = (
  snapshot: ActivatedRouteSnapshot,
): RouterStateUrl => {
  const root = getLast(snapshot);
  const segments = [];
  const configuredSegments = [];

  root.pathFromRoot.forEach((v) => {
    segments.push(...v.url.map((u) => u.path.toLowerCase()));
    if (v.routeConfig?.path)
      configuredSegments.push(...v.routeConfig.path?.split('/'));
  });

  return {
    url: segments.join('/'),
    configuredUrl: configuredSegments.join('/'),
    segments,
    configuredSegments: configuredSegments,
    params: root.params,
    data: root.data,
    queryParams: root.queryParams,
  };
};
